export const getClients = ({ clients }) => clients.clients;
